import { h, Component } from 'preact';
import { lastItem } from 'Misc/collections';
import UpperControls from './UpperControls/UpperControls';
import PlayPause from './PlayPause/PlayPause';
import { update } from 'Emitter';
import { UI, MEASUREMENT } from 'StateEvents';
import Share from './Share/Share';
import Click from './Click';
import Toast from './Toast/Toast';
import Mute from './Mute/Mute';
import NielsenSurvey from './Surveys/NielsenSurvey';
import Icons from './Icons';

const HIDE_IN = 1000;

export default class RootControl extends Component {
  constructor() {
    super();
    this.onMouseMove(); // display controls briefly on start so the user knows they're there
  }

  onMouseMove(evt) {
    update(UI.HOVERED, 'onMouseMove', true);

    if(this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      update(UI.HOVERED, 'onMouseMove', false);
    }, HIDE_IN);
  }

  onMouseEnter(evt) {
    update(UI.HOVERED, 'onMouseMove', true);
  }

  onMouseLeave(evt) {
    update(UI.HOVERED, 'onMouseMove', false);
  }

  applyStyles(props) {
    return `components hover-${props.state.display.hover}`;
  }

  canDisplayToast(props) {
    return props.changes.display.shares && lastItem(props.state.display.shares) === 'link' && props.state.configuration.UI.click;
  }

  onSurveyComplete(result = {}) {
    if(result.invalid) {
      update(MEASUREMENT.SURVEY_INVALID, 'onSurveyComplete');
    } else {
      update(MEASUREMENT.SURVEY_COMPLETE, 'onSurveyComplete', true);
    }
  }

  render(props) {
    return (
      <div 
        id="aa-video-ad-unit" 
        class={ this.applyStyles(props) } 
        onMouseMove={ this.onMouseMove.bind(this) }
        onMouseEnter={ this.onMouseEnter.bind(this) }
        onMouseLeave={ this.onMouseLeave.bind(this) }
      >
        <PlayPause paused={ props.state.media.paused || !props.state.media.started } />
        <UpperControls media={ props.state.media } options={ props.state.configuration.UI } />
        <Share options={ props.state.configuration.UI } />
        <Click options={ props.state.configuration.UI } />
        <Toast display={ this.canDisplayToast(props) } />
        <Mute display={ props.state.media.volume === 0 } options={ props.state.configuration.UI } />
        <NielsenSurvey state={ props.state } changes={ props.changes } onSurveyComplete={ this.onSurveyComplete.bind(this) } />
        <Icons icons={ props.state.configuration.UI.icons } media={ props.state.media } />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Display/Components/RootControl.js